import React, { useContext, useState } from 'react'
import ModuloAcceso from '../ModulosAccesos/ModuloAcceso';
import permisos from '../Tools/VerificarPermisos'
import AdmiAlarmas from '../AdministrarAlarmas/AdmiAlarmas'
import { ContextGloball } from '../Context/ContextGlobal';
import MenuHerramientas from '../ModuloSistemas/MenuHerramientas';
function MenuConfigWeb() {
    const { setTitulo } = useContext(ContextGloball);
    const [subVentana, setSubVentana] = useState(0);
    const validarVentana = (item) => {
        var cls = subVentana === item ? "itemMenuOk w-100" : "itemMenu w-100";
        return cls;
    }
    function getContenido() {
        if (subVentana==2){
            return(<ModuloAcceso />)
        }else if (subVentana==1){
            return(<AdmiAlarmas />)
        }else if (subVentana == 3){
            return(<MenuHerramientas/>)
        }
    }
    return (
        <>
            {subVentana == 0 && <div className='container-fluid py-2'>
                <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-1'>
                    {permisos.validarPermiso('34') && <div className='col col-sm-6 col-md-4'>
                        <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(1)}`}
                            onClick={() => { setSubVentana(1); setTitulo('Sucursal Alarmas'); }}>
                            <i className="fa-solid fa-bell"></i><span className="ms-1 "> Sucursal Alarmas</span></a>
                    </div>}
                    {permisos.validarPermiso('17') && <div className='col col-sm-6 col-md-4'>
                        <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(2)}`}
                            onClick={() => { setSubVentana(2); setTitulo('Modulos Permisos'); }}>
                            <i className="fa-solid fa-screwdriver-wrench"></i><span className="ms-1 "> Modulos Acceso</span></a>
                    </div>}
                    {permisos.validarPermiso('6') && <div className='col col-sm-6 col-md-4'>
                        <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(3)}`}
                            onClick={() => { setSubVentana(3); setTitulo('Modulos Sistemas'); }}>
                            <i className="fa-solid fa-sitemap"></i><span className="ms-1 "> Modulos Sistemas</span></a>
                    </div>}
                </div>
            </div>}
            {getContenido()}
            {subVentana !== 0 && <button className='btn text-danger btn-flotante' onClick={() => { setTitulo('Configurar Web'); setSubVentana(0) }}><i className="fa-solid fa-circle-xmark fa-2xl"></i></button>}
        </>
    )
}

export default MenuConfigWeb